import React, { useState } from 'react'
import { Button, Dropdown, Form, Input } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'

export default function DirectorySyncGroupMapping({
  groupMappings,
  onChange,
  workosDirectoryType,
  modalComponent,
  handleSaveAndSync,
  disabledSaveAndSync,
  loadingSaveAndSync,
  isSyncedGroupDone,
}: DirectorySyncGroupMappingProps) {
  const [searchInput, setSearchInput] = useState('')
  const [groupMappingSearch, setGroupMappingSearch] = useState(groupMappings)

  const handleChange = (role: string, groupId: string) => {
    const index = groupMappings.findIndex((groupMapping) => groupMapping.group_id === groupId)

    if (index !== -1) {
      const newMapping = [...groupMappings]
      newMapping[index] = {
        ...newMapping[index],
        simplesat_role: role,
      }
      setGroupMappingSearch(newMapping)
      onChange(newMapping)
    }
  }

  const handleSearchChange = (e) => {
    const searchVal = e.target.value.toLowerCase()
    setSearchInput(searchVal)
  }

  return (
    <React.Fragment>
      <modalComponent.Header>Group mapping</modalComponent.Header>
      {isSyncedGroupDone ? (
        <React.Fragment>
          <modalComponent.Content>
            <p>
              Configure the mapping of user groups to roles within Simplesat. If a user belongs to
              multiple groups, they will be assigned to the group with the highest level of
              permissions.
            </p>

            <Input
              icon="far fa-magnifying-glass"
              placeholder="Search directory groups"
              iconPosition="left"
              fluid
              onChange={handleSearchChange}
              className="mb-5"
            />

            <Form>
              {groupMappingSearch
                ?.filter((e) => e.group.toLowerCase().includes(searchInput.toLowerCase()))
                .map((mapper, index) => (
                  <div className="!p-0" key={mapper.group_id + mapper.group}>
                    <Form.Group className="flex-wrap">
                      <Form.Field>
                        {index === 0 && <label className="mb2">{workosDirectoryType} group</label>}
                        <div>
                          <Form.Input
                            value={mapper.group}
                            readOnly
                            input={{
                              style: {
                                background: 'rgba(244, 244, 244, 0.8)',
                                color: 'rgb(55, 63, 70)',
                                opacity: 0.7,
                                cursor: 'default',
                                pointerEvents: 'none',
                              },
                            }}
                          />
                        </div>
                      </Form.Field>
                      <Form.Field>
                        {index === 0 && <label className="!text-transparent mb2">{`>`}</label>}
                        <div style={{ padding: '6px 4px' }}>
                          <i className="far fa-arrow-right-long" />
                        </div>
                      </Form.Field>
                      <Form.Field>
                        {index === 0 && <label className="mb2">Simplesat role</label>}
                        <div>
                          <Dropdown
                            selection
                            search
                            options={simplesatRoleOptions}
                            value={mapper.simplesat_role || 'do_not_sync'}
                            onChange={(_, { value }) => handleChange(value, mapper.group_id)}
                          />
                        </div>
                      </Form.Field>
                    </Form.Group>
                  </div>
                ))}
            </Form>
          </modalComponent.Content>
          <modalComponent.Actions>
            <Button
              primary
              onClick={handleSaveAndSync}
              disabled={disabledSaveAndSync}
              loading={loadingSaveAndSync}
            >
              Save and sync mapping
            </Button>
          </modalComponent.Actions>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <modalComponent.Content>
            <p>
              Configure the mapping of user groups to roles within Simplesat. If a user belongs to
              multiple groups, they will be assigned to the group with the highest level of
              permissions.
            </p>
            <div className="text-[#A5ADBA]">
              <Loader withContainer containerHeight={50} />
              <div className="flex flex-col justify-center items-center">
                <h2>Fetching groups</h2>
                <div>This can take several minutes for directories with many groups</div>
              </div>
            </div>
          </modalComponent.Content>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export interface GroupMapping {
  group_id?: string
  group: string
  simplesat_role?: string
  id?: string
}

interface DirectorySyncGroupMappingProps {
  groupMappings: GroupMapping[]
  onChange: (groupMappings: GroupMapping[]) => void
  workosDirectoryType: string
  handleSaveAndSync: () => void
  modalComponent: React.ComponentType<any>
  disabledSaveAndSync: boolean
  loadingSaveAndSync: boolean
  isSyncedGroupDone: boolean
}

const simplesatRoleOptions = [
  { key: 'admin', text: 'Admin', value: 'admin' },
  { key: 'manager', text: 'Manager', value: 'manager' },
  { key: 'collaborator', text: 'Collaborator', value: 'collaborator' },
  { key: 'billing', text: 'Billing', value: 'billing' },
  { key: 'do_not_sync', text: 'Do not sync', value: 'do_not_sync' },
]



// WEBPACK FOOTER //
// ./src/components/DirectorySyncGroupMapping/index.tsx